import React, { memo } from 'react';

// These used for datagrid_reference and milestone as well, which have different structure. Should replace & cleanup

export const valueGetter = (params) => {
  if(!params.data) return null;
  return _.isObject(params.data[params.colDef.field]) ? params.data[params.colDef.field]['id'] : params.data[params.colDef.field]
};

export const valueFormatter = ({value, data, colDef, colDef: { cellRendererParams }}) => {
  let newValue = cellRendererParams.optionMap?.get(value);
  if (_.isUndefined(newValue) && _.isObject((data||{})[colDef.field])) {
    // Not sure when this would exist
    newValue = data[colDef.field]?.['label'];
    return _.isObject(newValue) ? newValue['label'] : newValue;
  }

  if (_.isObject(newValue)) return newValue['label'];

  return newValue;
};

export const validateSelectionCell = ({value, data, colDef, colDef: { cellRendererParams }}) => {
  if (!value) return true; // No value, consider valid

  if (cellRendererParams.optionMap == undefined || cellRendererParams.optionMap.size == 0) return true; // No options, consider valid

  if (data[colDef.field]?.['id'] == value || data[colDef.field]?.['label'] == value) return true; // Value Exists in data, consider valid

  let checkAgainst = Array.isArray(value) ? value : [value];
  return checkAgainst.every(v => cellRendererParams.optionMap.has(v))
};
